// ex common-critical

/* Since webpack5, exposing loaders globally AND importing libs manually creates a blocking warning
 * due to some kind of conflicts. Adding "true" option means override=true.
 * As you guess, it will override every other global value with the same name
 * https://webpack.js.org/loaders/expose-loader/#exposes
 *
 * We can probably remove this import as everytime we need it, we import it manually.
 * But for now, let's keep it, bundle has the same weight...
 */
import 'expose-loader?exposes=Awesomplete|Awesomplete|true!awesomplete';
import 'expose-loader?exposes=bowser!bowser';

import '../Hop/polyfills-index';
import '../dom/helpers';

import '../Hop/core-hop';
import '../Hop/core-critical';
import '../Hop/components/load-css-file';

import '../Hop/components/main-search/main-search_form';

// Only online features
import '../Hop/components/main-header/main-header-notif';
//

import '../Hop/autocomplete';

// ex common-secondary
import 'script-loader!terser-loader!outdatedbrowser/outdatedbrowser/outdatedbrowser';
import '@malt/handlebars/src/runtime';
import 'script-loader!terser-loader!vanilla-lazyload/dist/lazyload.min';
import 'script-loader!terser-loader!jquery';
import 'script-loader!terser-loader!domurl';

import 'script-loader!terser-loader!../libs/jquery.jsonp';
import '../Hop/core-secondary';
import '../Hop/core.extend';
import '../Hop/components/alerting';
import '../Hop/components/tracking/ga';
import '../Hop/components/tracking/gtm';
import '../Hop/components/tracking/onload-tracking';
import '../Hop/components/tracking/track-text-selection';
import '../Hop/components/image/avatar-initials';
import '../Hop/components/general-ui/buttons';
import '../Hop/components/general-ui/copy-content-to-clipboard';
// Only for logged-in users
import '../Hop/components/company/share-link-invitation';
//
import '../Hop/components/link';
import '../Hop/popover';
import '../Hop/forms';
import '../Hop/aria-alert';
import '../Hop/print';
import '../Hop/components/display-toggle';
import 'script-loader!terser-loader!../Hop/dropdown-bugfix';
import '../Hop/components/supportCatchMail';
import '../Hop/components/general-ui/navigation/anchor-link';
import '../Hop/components/postLink';
import '../Hop/components/renderJson';
import '../Hop/components/loader';
import '../Hop/components/password-constraint-checker';
import '../Hop/components/popin';
import '../Hop/components/main-header/mobile-banner';
// Only online features
import '../Hop/components/main-header/main-header-nav';
import '../Hop/components/main-header/main-header-identities';
import '../Hop/components/main-header/brief-entrust-my-research-tooltip';
import '../Hop/components/main-header/country-launching-banner';
//
import '../Hop/footer-change-locale';
import '../libs/lazyload';
import 'picturefill';
import 'script-loader!terser-loader!../Hop/components/image/img-lazyload';
import 'script-loader!terser-loader!../libs/progress-button-custom';
import '../Hop/show-alert';
import '../Hop/components/show-password';

// bootstrap
import 'script-loader!terser-loader!bootstrap-sass/assets/javascripts/bootstrap/transition';
import 'script-loader!terser-loader!bootstrap-sass/assets/javascripts/bootstrap/collapse';
import 'script-loader!terser-loader!bootstrap-sass/assets/javascripts/bootstrap/modal';
import 'script-loader!terser-loader!bootstrap-sass/assets/javascripts/bootstrap/tooltip';
import 'script-loader!terser-loader!bootstrap-sass/assets/javascripts/bootstrap/popover';
import 'script-loader!terser-loader!bootstrap-sass/assets/javascripts/bootstrap/tab';
import 'script-loader!terser-loader!bootstrap-sass/assets/javascripts/bootstrap/carousel';

import 'script-loader!terser-loader!../jquery-ext-hopwork';

// Only reset password
// We don't need script-loader as we don't need to inject sendRenewal globally.
import '../renewal';
//

// Need this only if we click on signin or signup
import '../connectPopup';
import '../switch-signup-signin-type';
//

// Only online features
import '../Hop/legal-update-acceptance';
//
import '../Hop/align';
import '../Hop/menu.email.validation';
import '../Hop/components/tracking/cookie-use-warning';
// Only online features
import '../Hop/components/intro';
import '../Hop/components/trigger-invitation-modal';
import '../Hop/components/company/members-invitation-modal';
import '../Hop/components/company/modal-proposal-draft';
import '../Hop/components/company/modal-check-country';
import '../Hop/components/group/group-invitation-modal';
//

import '../Hop/components/alert-unverified-brief-modal';
// @Todo Remove this line when ff4j header-v2 is cleaned
import '../Hop/components/main-header/main-header-search';
import '../Hop/components/main-header/main-header-search-v2';
// Only online features
import '../Hop/components/main-header/main-header-search-highlight';
//
import '../location-plugin';

// Only after signup
import '../Hop/components/signup/signup-confirm';
//
import '../authentication/sso-email-check';

import {RatingStars} from 'malt-joy/src/js/RatingStars/RatingStars';

new RatingStars();

// REBRANDING 2020 //
import '../rebrand2020';

import '../language-selector/language-selector';
import '../language-selector/language-selector-modal';
